import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import React, { useEffect, useState } from 'react';
import useMyMApi from '../../hooks/useMyMApi';
import useWebContext from '../../hooks/useWebContext';
import { MyMModal } from '../../ui-elements/MyMModal';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import MetadataApliableFilterCard from '../../ui-parts/MetadataApliableFilterCard';
import { utility } from '../../utility';
import Preview, { previewModalSize } from '../MyM906_Preview/Preview';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';
import AssetLibraryCard from '../MyM325_AssetLibrary/AssetLibraryCard';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';

/**MyMine Version3.0 AssetLibrary画面新規追加
 * Marketing Page Component
 */
const AssetLibrary = (props) => {
  const screenId = 'MyM325';
  const { controlSettings, messageList, screenSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewFileId, setPreviewFileId] = useState(false);
  const handleModalClose = () => setIsModalOpen(false);
  const [offset, setOffset] = useState(0);
  const [searchResult, setSearchResult] = useState(null);
  const [filterList, setFilterList] = useState(null);
  const [selectedSortBy, setSelectedSortBy] = useState(0);
  const [apliableFilterList, setApliableFilterList] = useState([]);
  const [isInitLoaded, setIsInitLoaded] = useState(false);
  const [checkedList, setCheckedList] = useState([]);
  const isPc = useMediaQuery(mediaQuery.pc);
  const [totalCount, setTotalCount] = useState(0);

  // ソート順のDropDownList用変数
  const sortByDDL = [
    { value: 0, text: controlSettings.LabelList.ddlSortBy1, sortItem: 'UPLOAD_DATE DESC' },
    { value: 1, text: controlSettings.LabelList.ddlSortBy2, sortItem: 'UPLOAD_DATE ASC' },
    { value: 2, text: controlSettings.LabelList.ddlSortBy3, sortItem: 'EXTENSION ASC' },
    { value: 3, text: controlSettings.LabelList.ddlSortBy4, sortItem: 'NAME_DISP ASC' },
  ];

  /**
   * プレビュー処理
   * @param {Event} e イベント引数
   * @param {string} fileId ファイルID
   */
  const onClickPreview = (e, fileId) => {
    setPreviewFileId(fileId);
    setIsModalOpen(true);
  }

  /**
   * SortByドロップダウンリスト変更時処理
   * @param {any} e イベント引数
   */
  const handleSortByChange = (e) => {
    setSelectedSortBy(e.target.value);
  }

  /** 初期表示時 */
  useEffect(() => {

    /**
     * 初期情報取得正常コールバック処理
     * @param {any} result 処理結果
     */
    const callbackSearchResultLoadSuccess = (result) => {
      setSearchResult(result.Result);
      setFilterList(result.FilterList);
      setTotalCount(result.Result.TotalRecordCount)
      setOffset(result.Result.Offset + result.Result.ItemList.length);
      setIsLoading(false);
    }

    /**
     * 初期情報取得失敗コールバック処理
     * @param {any} result処理結果
     */
    const callbackSearchResultLoadFaild = (result) => {
      // 通信がエラーとなった場合ローディング状態を解除
      setIsLoading(false);
    }

    const paramObj = {
      SortItems: `${sortByDDL[selectedSortBy].sortItem}`,
      LimitMaxRowCount: screenSettings.MaxRowCount,
      ...(apliableFilterList.length > 0 ? {
        FilterMetadataIds: apliableFilterList.join(',')
      } : {}),
      Offset: 0
    };

    apiRequest.requestJson(`api/asset-library/list-page-load?${utility.makeEncodeParameter(paramObj)}`, 'GET', callbackSearchResultLoadSuccess, callbackSearchResultLoadFaild);
    setIsInitLoaded(true);
  }, []);

  const scrollToTop = () => {
    const scrollableDiv = document.getElementById('scrollableDiv');
    if (scrollableDiv) {
      scrollableDiv.scrollTop = 0; // ← スクロールを一番上へ
    }
  };

  /** フィルタ適用時 */
  useEffect(() => {
    if (isInitLoaded === false) { return; }
    requestSearch();
  }, [apliableFilterList]);

  /** ソート/ページング切り替え時 */
  useEffect(() => {
    if (isInitLoaded === false) { return; }
    requestSearch();
  }, [selectedSortBy]);

  /** リクエスト処理  */
  const requestSearch = () => {


    /**
     * 一覧ページ取得正常コールバック処理
     * @param {any} result 処理結果
     */
    const callbackSuccessSearchResultPage = (result) => {
      scrollToTop();
      setSearchResult(result);  
      setOffset(result.Offset + result.ItemList.length);
      setTotalCount(result.TotalRecordCount);
      setIsLoading(false);
    }

    /**
     * 一覧ページ取得失敗コールバック処理
     * @param {any} result処理結果
     */
    const callbackFaildSearchResultPage = (result) => {
      // 通信がエラーとなった場合ローディング状態を解除
      setIsLoading(false);
    }

    setIsLoading(true);

    const paramObj = {
      Offset: 0,
      LimitMaxRowCount: screenSettings.MaxRowCount,
      SortItems: `${sortByDDL[selectedSortBy].sortItem}`,
      FilterMetadataIds: apliableFilterList.join(','),
    };

    apiRequest.requestJson(`api/asset-library/list-page?${utility.makeEncodeParameter(paramObj)}`, 'GET', callbackSuccessSearchResultPage, callbackFaildSearchResultPage);
  }

  const scrollRequestSearch = () => {
    setIsLoading(true);
    const paramObj = {
      Offset: offset,
      LimitMaxRowCount: screenSettings.MaxRowCount,
      SortItems: `${sortByDDL[selectedSortBy].sortItem}`,
      FilterMetadataIds: apliableFilterList.join(','),
    };

    const callbackSuccessSearchResultPage = (result) => {
      setSearchResult(prev => ({
        ...prev,
        ItemList: [...(prev?.ItemList || []), ...result.ItemList],
        Offset: result.Offset + result.ItemList.length
      }));
      setOffset(prev => prev + result.ItemList.length);
      setIsLoading(false);
    };

    const callbackFaildSearchResultPage = () => {
      setIsLoading(false);
    };

    apiRequest.requestJson(`api/asset-library/list-page?${utility.makeEncodeParameter(paramObj)}`, 'GET', callbackSuccessSearchResultPage, callbackFaildSearchResultPage);
  };

  if (searchResult === null)
    return <MyMProgress />

  return (
    <>
      <Box sx={{ textAlign: 'left' }}>
        <MyMVariantLabel variant='h5'>{controlSettings.LabelList.lblAssetLibraryTitle}</MyMVariantLabel>
        <MyMLabel>{controlSettings.LabelList.lblAssetLibraryDescription}</MyMLabel>
      </Box>
      <Box>
        <Grid container>
          <Grid item xs={12} lg={9} >
            <AssetLibraryCard
              screenId={screenId}
              searchResult={searchResult}
              onSortByChange={handleSortByChange}
              onClickPreview={onClickPreview}
              controlSettings={controlSettings}
              messageList={messageList}
              sortByDDL={sortByDDL}
              selectedSortBy={selectedSortBy}
              setIsLoading={setIsLoading}
              screenSettings={screenSettings}
              isLoading={isLoading}
              metadataList={filterList}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
              setApliableFilterList={setApliableFilterList}
              scrollRequestSearch={scrollRequestSearch}
              hasMore={searchResult.ItemList.length < totalCount}
            />
          </Grid>
          {isPc && (
            <Grid item xs={12} lg={3}>
              <MetadataApliableFilterCard
                cardTitle={controlSettings.LabelList.lblFilterResultsByTitle}
                metadataList={filterList}
                controlSettings={controlSettings}
                setApliableFilterList={setApliableFilterList}
                checkedList={checkedList}
                setCheckedList={setCheckedList}
                isAsset={true}
              />
            </Grid>
          )}
        </Grid>
        <MyMModal
          open={isModalOpen}
          onClose={handleModalClose}
          {...previewModalSize}
        >
          <Preview fileId={previewFileId} onPreviewFailed={handleModalClose} />
        </MyMModal>
      </Box>
    </>
  );

}
export default AssetLibrary;